import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type State = {
	loading: boolean;
	version: string;
	proxyUrl: string;
	apiUrl: string;
	apiDevUrl: string;
	gatewayUrl: string;
	isDev: boolean;
	isDevServer: boolean;
};

type Action = {
	setLoading: (loading: boolean) => void;
	getApiUrl: () => string;
	setIsDevServer: (isDev: boolean) => void;
};

const useGlobalStore = create<State & Action>()(
	// persist(
	immer<State & Action>((set, get) => ({
		loading: false,
		version: "3.0.3",
		isDev: __DEV__,
		isDevServer: false,
		setLoading: (loading) =>
			set((state) => {
				state.loading = loading;
			}),
		proxyUrl: "https://ps-uxp.oplux.ai",
		apiUrl: "https://ps-uxp.oplux.ai/api",
		apiDevUrl: "https://ps-uxp.oplux.ai/api-dev",
		gatewayUrl: "https://ps-uxp.oplux.ai/gateway",
		getApiUrl: (): string => {
			const state = get();
			return state.isDevServer ? state.apiDevUrl : state.apiUrl;
		},
		setIsDevServer: (isDev: boolean) =>
			set((state) => {
				state.isDevServer = isDev;
			}),
	})),
	// {
	// 	name: "oplux-ps-plugin-storage",
	// 	partialize: (state) => ({
	// 	}),
	// },
	// ),
);

export { useGlobalStore as globalStore, useGlobalStore };
